module.exports = __webpack_public_path__ + "img/drama_popup_center.047d58e1.png";